/* eslint no-underscore-dangle: 0 */
import { MEDIA_TYPE } from '../Utils/vice-constants';

class ScreensharePreprocessor {
  // constructor to pass coordinates for cropping
  constructor(coordinates) {
    this.coordinates = coordinates;
  }

  /**
   * Check whether browser supports MediaStreamTrackProcessor
   * and MediaStreamTrackGenerator
   * @returns boolean
   */

  _isSupported =
    typeof window.MediaStreamTrackProcessor !== 'undefined' &&
    typeof window.MediaStreamTrackGenerator !== 'undefined';

  isMediaProcessingSupported = () => this._isSupported;

  // eslint-disable-next-line class-methods-use-this
  getSampleAlignedCoordinate(value) {
    return value % 2 === 0 ? value : value - 1;
  }

  // coordinates

  // TODO: Move this into a Web Worker
  /**
   * A transformer function to crop each frame of a video track
   * @param {*} frame
   * @param {*} controller
   */
  cropVideoTrack = (frame, controller) => {
    const _width = this.coordinates.width;
    const _height = this.coordinates.height;
    const newFrame = new window.VideoFrame(frame, {
      visibleRect: {
        x: this.getSampleAlignedCoordinate(this.coordinates.left),
        y: this.getSampleAlignedCoordinate(this.coordinates.top),
        width: _width,
        height: _height,
      },
    });
    controller.enqueue(newFrame);
    frame.close();
  };

  /**
   * Crop a video track of a screenshare
   * @param {object} track - MediaStreamTrack
   * @returns
   */
  cropMediaTrack = (track) => {
    if (this.isMediaProcessingSupported()) {
      const mainTrack = track.getVideoTracks()[0] ?? track;
      const generator = new window.MediaStreamTrackGenerator({ kind: MEDIA_TYPE.VIDEO });
      const generatedStream = new window.MediaStream([generator]);
      const processor = new window.MediaStreamTrackProcessor({ track: mainTrack });

      processor.readable
        .pipeThrough(
          new window.TransformStream({
            transform: this.cropVideoTrack,
          }),
        ) // Look at another way of passing this.
        .pipeTo(generator.writable);
      return generatedStream;
    }
    throw new Error('Media preprocessing is not supported');
  };
}

export default ScreensharePreprocessor;
